import request from '../../utils/request'
import { judgePermissions } from '@/utils/common.js'

const state = {}

const actions = {
    // 获取考试数据备份列表
    getBackupList({ dispatch }, data) {
        return new Promise((resolve)=>{
            judgePermissions(['backup:list']).then(res => {
                if (res) {
                    request({
                        url: `/api/exam/backup`,
                        method: 'get',
                        params: data
                    }).then((data)=>{
                        resolve(data);
                    })
                }else {
                    resolve({data:null})
                }
            })
        })
    },
}

export default {
    state,
    actions
}
